import React, { useCallback } from 'react';
import Input from '../components/Input';
import useFetchThreshold from '../features/Devices/threshold/useFetchThreshold';
import Toggle from '../components/Toggle';
import CableIcon from '@mui/icons-material/Cable';
import Accordion from '../components/Accordion';
import FormWaterTariff from '../features/Devices/waterTariffs/FormWaterTariff';
import SettingDataForm from '../features/Devices/counter/SettingDataForm';
import { initialCounterSubtype } from '../features/Devices/constants/constants';
import Dropdown from '../components/Dropdown';
import CustomDatePicker from '../components/CustomDatePicker';

const AnyDeviceEditor = ({ setDeviceToEdit, deviceToEdit }) => {
  const subType = deviceToEdit?.type?.sub_type?.key;
  const isCounter = deviceToEdit?.type?.key === 'counter';
  const { threshold, setThreshold, status, setStatus, updateStatusThreshold } = useFetchThreshold(deviceToEdit.id, isCounter);
  const [accordion, setAccordion] = React.useState({ 0: true });

  const handleChangeStatus = useCallback(
    async (value) => {
      try {
        await updateStatusThreshold(value);
        setStatus(value);
      } catch (err) {}
    },
    [setStatus, updateStatusThreshold]
  );

  const subtypeValue = deviceToEdit?.device_subtype_id ?? initialCounterSubtype.find((s) => s.device_type === subType)?.device_subtype_id;

  return (
    <div className="px-4">
      <Input
        classContainer={'w-full mt-4'}
        value={deviceToEdit.serial_number}
        inputCb={(e) =>
          setDeviceToEdit({
            ...deviceToEdit,
            serial_number: e.target.value,
          })
        }
        disabled={!isCounter}
        label="Серийный номер"
        id="type"
        type="text"
        placeholder={'A123'}
      />
      <Input
        classContainer={'w-full my-4'}
        value={deviceToEdit.description}
        inputCb={(e) =>
          setDeviceToEdit({
            ...deviceToEdit,
            description: e.target.value,
          })
        }
        label="Место установки устройства"
        id="descr"
        type="text"
        placeholder={'Например: ванная, санузел, кухня'}
      />
      {isCounter && (
        <>
          <Dropdown
            className={'pb-4'}
            label={'Подтип устройств'}
            options={initialCounterSubtype}
            value={subtypeValue}
            inputCb={(e) => setDeviceToEdit({ ...deviceToEdit, device_subtype_id: +e.target.value })}
            id="type"
            valkey="device_subtype_id"
            optkey="category"
          />
          <CustomDatePicker
            placeholderText={'Выберите дату'}
            showTimeSelect={false}
            dateFormat={'dd.MM.yyyy'}
            className={'rounded-full mb-4 pl-3'}
            label={'Дата поверки'}
            selected={deviceToEdit?.verification_date ? new Date(deviceToEdit.verification_date) : null}
            onChange={(date) => setDeviceToEdit({ ...deviceToEdit, verification_date: date })}
          />

          <Accordion accordion={accordion} setAccordion={setAccordion} id={'two'} Icon={CableIcon} name={'Настройка расхода воды'}>
            <Input
              classContainer={'w-full mt-4'}
              value={threshold?.daily_threshold ?? ''}
              inputCb={(e) => {
                const val = e.target.value;
                if (val === '') {
                  setThreshold({ ...threshold, daily_threshold: '' });
                } else {
                  const num = Number(val);
                  if (num >= 0) {
                    setThreshold({ ...threshold, daily_threshold: num });
                  }
                }
              }}
              label="Дневной порог расхода воды, литры"
              id="type"
              type="number"
              placeholder={'1'}
            />
            {threshold?.id && (
              <div className="w-full mt-4">
                <Toggle label={'Использовать дневной порог воды'} value={status} onChange={handleChangeStatus} />
              </div>
            )}
            <FormWaterTariff tariffs={deviceToEdit?.tariffs} />
            <div className={'text-xs pt-2 text-gray-600'}>*На основе указанных тарифов мы покажем вашу ориентировочную сумму затрат</div>
          </Accordion>
          <SettingDataForm deviceId={deviceToEdit?.id} />
        </>
      )}
    </div>
  );
};
export default AnyDeviceEditor;
